export const TYPES: any = {
    ChatService: Symbol('ChatService'),
    PlaceService: Symbol('PlaceService'),
    CustomPlaceService: Symbol('CustomPlaceService'),
    RoadLessonService: Symbol('RoadLessonService'),
    OldRoadLessonService: Symbol('OldRoadLessonService'),
    BattleLessonService: Symbol('BattleLessonService'),
    MenuService: Symbol('MenuService'),
    ResourceService: Symbol('ResourceService'),
    SceneService: Symbol('SceneService'),
    ExperienceService: Symbol('ExperienceService'),
    ArtifactService: Symbol('ArtifactService'),
    PlayerCreatureService: Symbol('PlayerCreatureService'),
    ConsumableService: Symbol('ConsumableService'),
    BattleService: Symbol('BattleService'),
    RuneService: Symbol('RuneService'),
    ShopService: Symbol('ShopService'),
    ArtifactNotificationService: Symbol('ArtifactNotificationService'),
    ForceNotificationService: Symbol('ForceNotificationService'),
    RewardService: Symbol('RewardService'),
    ArtifactLessonService: Symbol('ArtifactLessonService'),
    TaskService: Symbol('TaskService'),
    HealthService: Symbol('HealthService'),
    PlayerSpeedService: Symbol('PlayerSpeedService'),
    ProfileService: Symbol('ProfileService'),
    PaymentNotificationService: Symbol('PaymentNotificationService'),
    GameSoundService: Symbol('GameSoundService'),
    CampaignService: Symbol('CampaignService'),
    EnemyCreatureService: Symbol('EnemyCreatureService'),
    GenderChangeService: Symbol('GenderChangeService'),
    RenamePlayerService: Symbol('RenamePlayerService'),
    MailOrPhoneService: Symbol('MailOrPhoneService'),
    PasswordService: Symbol('PasswordService'),
    MagicPlaceService: Symbol('MagicPlaceService'),
    ClanService: Symbol('ClanService'),
    ListService: Symbol('ListService'),
    HeroShopService: Symbol('HeroShopService'),
    ForumService: Symbol('ForumService'),
    GiftService: Symbol('GiftService'),
    LawService: Symbol('LawService'),
    LawServiceBeeline: Symbol('LawServiceBeeline'),
    RateAppService: Symbol('RateAppService'),
    CapacitorService: Symbol('CapacitorService'),
    LocationService: Symbol('LocationService'),
    HeroTownShopService: Symbol('HeroTownShopService'),
    TitanTownShopService: Symbol('TitanTownShopService'),
    AngelTownShopService: Symbol('AngelTownShopService'),
    PaymentChangeService: Symbol('PaymentChangeService'),
    IapService: Symbol('IapService'),
    TenjinService: Symbol('TenjinService'),
    AppmetricaService: Symbol('AppmetricaService'),
    YotunTownShopService: Symbol('YotunTownShopService'),
    SurTownShopService: Symbol('SurTownShopService'),
    EducationService: Symbol('EducationService'),
    AmetistShopService: Symbol('AmetistShopService'),
    WaterShopService: Symbol('WaterShopService'),
    PortalShopService: Symbol('PortalShopService'),
    ShadowShopService: Symbol('ShadowShopService'),
    ChainService: Symbol('ChainService'),
    SaleService: Symbol('SaleService'),
    CaviarRankShopService: Symbol('CaviarRankShopService'),
    CaviarElephShopService: Symbol('CaviarElephShopService'),
    GiftGemsShopService: Symbol('GiftGemsShopService'),
};
